import {
  DISMISS_USERPERSONA_MODAL,
  CLOSE_USERPERSONA_MODAL,
  SHOW_USERPERSONA_MODAL
} from 'JS/actionCreators/marketingActions';

const initialState = {
  showUserpersonaModal: false
};

const marketingReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISMISS_USERPERSONA_MODAL:
    case CLOSE_USERPERSONA_MODAL:
      return {
        ...state,
        showUserpersonaModal: false
      };
    case SHOW_USERPERSONA_MODAL:
      return {
        ...state,
        showUserpersonaModal: true
      };
    default:
      return state;
  }
};

export default marketingReducer;
